<template>
  <PublicPageShell>
    <div aria-hidden="true" class="pointer-events-none absolute inset-0">
      <div
        class="absolute inset-0 bg-[radial-gradient(ellipse_at_center,rgba(0,0,0,0.4)_0%,rgba(0,0,0,0.5)_60%,rgba(0,0,0,0.95)_100%)]">
      </div>

      <div class="absolute -top-32 -left-24 h-[34rem] w-[34rem] rounded-full opacity-25 blur-3xl"
        :style="{ background: 'radial-gradient(circle at 30% 30%, var(--color-scio-yellow-p2) 0%, transparent 60%)' }">
      </div>
    </div>

        <!-- Header -->
        <header class="relative z-10">
            <div class="h-8"></div>
            <div class="mx-4 sm:mx-6">
                <!-- <img src="/icons/scio-logo.svg" alt="Scio" class="h-10 sm:h-12" /> -->
            </div>
            <div class="h-6"></div>
        </header>

        <!-- Hero -->
        <section class="relative z-10 bg-transparent">
            <div class="mx-auto max-w-7xl px-4 sm:px-6">
                <div class="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-start">
                    <!-- Copy block -->
                    <div class="lg:col-span-7 xl:col-span-6 ">
                        <span class="inline-block rounded-full px-3 py-1 scio-text-meta scio-weight-medium tracking-wide"
                            :style="{ color: 'var(--color-scio-yellow-p2)' }">
                            Welcome to Scio
                        </span>

                        <h1 class="mt-3 text-4xl/tight text-white sm:text-5xl/tight md:text-6xl/tight scio-weight-heading">
                            Know what will break
                            <span :style="{ color: 'var(--color-scio-yellow-p2)' }">before</span>
                            you commit.
                        </h1>
                        <p class="mt-6 scio-body-1 sm:scio-text-lead text-neutral-200 max-w-2xl">
                            Scio turns incomplete early programme data into quantified delivery scenarios—so major
                            infrastructure teams can make faster, more confident decisions about what is actually
                            buildable.
                        </p>

                        <!-- Actions -->
                        <div class="mt-8 flex flex-wrap gap-3">
                            <button type="button"
                                class="cursor-pointer inline-flex items-center justify-center rounded-md px-4 py-2 scio-text-body scio-weight-semibold shadow-sm transition
                       focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-neutral-200/60 focus-visible:ring-offset-neutral-950"
                                :style="{ backgroundColor: 'var(--color-scio-yellow-p2)', color: '#111827' }"
                                @click="$router.push('/programmes/')">
                                Get started
                            </button>
                        </div>
                    </div>
                </div>

                <div class="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-3">
                    <div v-for="answer in answers" :key="answer.label"
                        class="rounded-xl bg-white/5 p-5 ring-1 ring-white/10 backdrop-blur-sm">
                        <div class="scio-text-meta scio-weight-semibold" :style="{ color: answer.color }">{{ answer.label }}</div>
                        <div class="mt-2 scio-text-lead scio-weight-heading text-neutral-50">{{ answer.title }}</div>
                        <p class="mt-2 scio-text-body text-neutral-300">{{ answer.body }}</p>
                    </div>
                </div>

                <!-- Footer note -->
                <div class="mt-12 border-t border-white/10 pt-6 scio-text-meta text-neutral-200">
                    <span class="mr-2">© {{ new Date().getFullYear() }} Scio</span>
                    <span class="inline-block h-1 w-1 rounded-full bg-neutral-600 align-middle mx-2"></span>
                    <span>Clarity before commitment</span>
                </div>
            </div>
        </section>
    </PublicPageShell>
</template>

<script>
import scioAbstract from '@/assets/scio-abstract-01.svg';

export default {
    name: "Splash",
    data() {
        return {
            scioAbstract,
            answers: [
                { label: "WHAT", title: "A decision model", body: "Scope, sequence, resources, cost, carbon and logistics in one view.", color: "var(--color-scio-yellow-p1)" },
                { label: "WHY", title: "Fewer late surprises", body: "Find the constraint, the failure window and the levers that change the outcome.", color: "var(--color-scio-yellow-p2)" },
                { label: "WHEN", title: "Before it is expensive", body: "Use it at masterplanning, feasibility and concept—before design and contracts lock in.", color: "var(--color-scio-yellow-p3)" }
            ]
        };
    }
};
</script>


<style>
@media (prefers-reduced-motion: no-preference) {
    .orbit-drift {
        animation: drift 12s ease-in-out infinite alternate;
    }

    @keyframes drift {
        from {
            transform: translate(600px, 360px) rotate(-2deg);
        }

        to {
            transform: translate(600px, 360px) rotate(2deg);
        }
    }
}
</style>
